const focus = {
// 指令的定义
  inserted: function (el) {
    el.focus();
  }
};

export { focus };
